const colors = {
  primary900: '#005751',
  primary800: '#007470',
  primary700: '#008481',
  primary600: '#009592',
  primary500: '#00A2A1',
  primary400: '#00B1B2',
  primary: '#28BFC2',
  primary200: '#75D2D5',
  primary100: '#AEE3E5',
  primary50: '#DFF4F5',

  secondary900: '#00963C',
  secondary800: '#3DBB4D',
  secondary700: '#53D057',
  secondary600: '#6BE762',
  secondary500: '#7BF96C',
  secondary400: '#8EFC80',
  secondary: '#A7FF9A',
  secondary200: '#C3FFB9',
  secondary100: '#DBFFD5',
  secondary50: '#F1FFEE',

  gray900: '#252729',
  gray800: '#46494B',
  gray700: '#66686B',
  gray600: '#7A7D7F',
  gray500: '#A4A6A9',
  gray400: '#C2C4C8',
  gray300: '#E4E7EA',
  gray200: '#EFF2F5',
  gray100: '#F4F7FA',
  gray50: '#F9FBFF',
  lighterGray: '#E1E2E4',
  lightGray: '#F3F4F6',
  darkGray: '#9E9FA0',
  scroll: '#D9D9D9',
  scroll50: 'rgba(62,62,62,0.5)',

  white33: 'rgb(255,255,255,0.33)',
  white15: 'rgb(255,255,255,0.15)',
  white05: 'rgb(255,255,255,0.5)',

  dimSoft: 'rgba(0,0,0,0.4)',
  dimHard: 'rgba(0,0,0,0.6)',

  strong: '#171717',
  normal: 'rgb(23,23,23,0.87)',
  assistive: 'rgb(23,23,23,0.7)',
  supportive: 'rgb(23,23,23,0.4)',
  disabled: 'rgb(23,23,23,0.15)',

  fill20: 'rgb(23,23,23,0.2)',
  fill12: 'rgb(23,23,23,0.12)',
  fill05: 'rgb(23,23,23,0.05)',
  fill03: 'rgb(23,23,23,0.03)',
  fill02: 'rgb(23,23,23,0.02)',

  alert: '#E12C25',
  alertHover: '#CF2922',
  alertPress: '#C62721',
  warning: '#FBB54A',
  success: '#3CCB39',
};

const shadows = {
  input: 'inset 0px 0px 0px 3px #dff4f5',
  card: '0px 1px 6px 0px rgba(0, 0, 0, 0.12)',
  box: '0px 3px 1px 0px rgba(0, 0, 0, 0.04), 0px 1px 6px 0px rgba(0, 0, 0, 0.12)',
  elevation01: '0px 1px 4px 0px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation02: '0px 2px 6px 1px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation03: '0px 3px 8px 2px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation04: '0px 3px 10px 2px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation05: '0px 4px 10px 3px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  elevation06: '0px 4px 10px 4px rgba(0, 0, 0, 0.25), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
};

export const theme = {
  colors,
  shadows,
};
